import React from "react";
import "./benefitsList.scss";
import checked_icon from "../../assets/checkedIconGreen.webp";
import { StaticImage } from "gatsby-plugin-image"
import { MyTheme } from "../../utils/informations"


const BenefitsList = ({ props }) => {
    return (

        <div className="benefit-container" id="landing-guide">

            <div className="benefit-content">
                <div className="benefit-title">
                    <h2>{props.title}</h2>
                </div>
                <div className="benefit-list">
                    {
                        props.benefits ? props.benefits.map((benefit, index) => {
                            return (
                                <div className="benefit" key={index}>
                                    <div className="benefit-flex">
                                        <img src={checked_icon} alt="product-benefits"></img>
                                        <p>{benefit.title}</p>
                                    </div>
                                    {
                                        benefit.description ?
                                            <p>{benefit.description}</p>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Level of component cover" ?
                                            <div id="level-component-cover">
                                                <p>- Most warranties will offer you parts and labour cover from day one, but with various levels of parts coverage, claim limits, labour rates, and maybe even whether to include wear and tear or not. Before buying, check the policy wording to make sure you are getting the level of cover you need for your vehicle. Some providers claim to offer “All Mechanical & Electrical” cover but then show listed parts only. On this site, all 4 & 5 Star policies are <b>“All Mechanical & Electrical”</b> cover.</p>                                                                                   
                                            </div>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Labour rate" ?
                                            <div>
                                                <p>On this comparison site you are offered a choice of labour rates, and you are free to choose your own dealer or use one of the ones approved by the administrator.</p>
                                                <p>£42.50 – This may be suitable for older vehicles only and where you will not be using main dealers.</p>
                                                <p>£60.00 or £70.00 – This may be suitable for slightly newer vehicles and is a rate offered by most chain service and repair companies or local repairers.</p>
                                                <p>£100.00 – This may be suitable for nearly new vehicles and may allow you to use some main dealers for repairs.</p>
                                                <p style={{ fontWeight: "700", marginTop: '15px' }}>We recommend that you check the current labour rate with your normal local garage that you currently use for servicing or repairs</p>
                                                <p style={{ fontWeight: '700', marginTop: '15px' }}>If you select a product that does not provide the labour rates required by the repairing garage, part of any claim you make may not be covered</p>
                                            </div>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Wear and Tear and Boost Upgrade" ?
                                            <div id="wear-and-tear">
                                               <p> <b>Wear and Tear</b> is damage that naturally and inevitably occurs because of normal wearing and aging. Some warranty providers offer this cover (at an additional cost), and some do not offer it. Check to see when Wear and Tear cover starts (any exclusion period) and when it might end - based on the vehicle age and mileage. Some providers end cover at 6 years and 60,000 miles.</p>
                                               <p> <b>Boost</b> may upgrade your level of cover to include failure of some / all the following Parts: Catalytic Convertor, Multimedia / Sound Equipment, Diesel Particulate Filter, Battery (<b><u>excluding</u></b> the “Drive Battery” that propels the vehicle) and Satellite Navigation Equipment. Please check the policy terms and conditions for each panel member or the “More Details “ button, next to the product pricing, for exact details of what is covered or excluded on each policy.</p>
                                            </div>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Full-service history" ?
                                            <div id="service-history">
                                                <p>A full-service history is evidence that the vehicle has been maintained at every required interval since it was built. The service history book should be completed as evidence. 
                                                By clicking 'Yes', you are confirming the vehicle either has a full-service history or will have been serviced in accordance with the manufacturer's recommendations within the last twelve months.</p>
                                            </div>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Pre-existing Faults" ?
                                            <div id="pre-existing-faults">
                                                <p>Most warranties (if not all) will not cover pre-existing faults – where you are aware of an issue or have been advised at the time of a service or MOT about an issue, prior to buying the warranty.</p>
                                                <p>On this site, you will be asked to confirm that there are no pre-existing faults that you are aware of and that there are no warning lights on the dashboard. By clicking 'Yes', you are confirming the vehicle is fault free and that you understand that the warranty will not cover any such faults.</p>
                                            </div>
                                            : ""
                                    }
                                    {
                                        benefit.title === "Faults found during a service or MOT" ?
                                            <div id="faults-service-mot">
                                                <p>Some warranty companies do <b>NOT</b> cover faults that are found during an MOT or routine service, unless you upgrade to a much more expensive level of cover, but this is not always clear on many aggregator / provider websites. Ensure that you check what level of cover you need to purchase and the price you will need to pay for that cover, when comparing prices and coverage.</p>                                        
                                            </div>
                                            : ""
                                    }
                                </div>
                            )
                        }) : ""
                    }

                </div>
            </div>
        </div>





    );
};

export default BenefitsList;
